import React from "react"

type BrandMarkProps = {
    height?: number
    className?: string
    title?: string
}

/** Cardiolyse wordmark — always shown as-is, regardless of tenant. */
const LOGO_URL = "/logo-c.svg";
const BRAND_NAME = "Cardiolyse";

export default function BrandMark(props: BrandMarkProps) {
    const {height = 20, className, title} = props;

    const brandName = title || BRAND_NAME;
    const mask = `url("${LOGO_URL}")`;

    return (
      <span
        className={className}
        role="img"
        aria-label={brandName || undefined}
        style={{
            display: "inline-block",
            width: "fit-content",
            verticalAlign: "middle",
            backgroundColor: "currentColor",
            WebkitMaskImage: mask,
            maskImage: mask,
            WebkitMaskRepeat: "no-repeat",
            maskRepeat: "no-repeat",
            WebkitMaskPosition: "left center",
            maskPosition: "left center",
            WebkitMaskSize: "contain",
            maskSize: "contain",
        }}
      >
          <img
            src={LOGO_URL}
            alt=""
            aria-hidden="true"
            height={height}
            style={{display: "block", width: "auto", visibility: "hidden"}}
          />
      </span>
    )
}
